import React, { memo } from 'react'

export const Logo = memo(() => {
  return (
    <div 
      className='header-logo'
      style={{ 
        height: '36px',
        width: '176px',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    />
  )
});
